import { useRef } from 'react';

import { IconButton, ClickAwayListener } from '@material-ui/core';

import {
  CompanyName,
  NameText,
  PopperArrow,
  RoleText,
  StyledAccountIcon,
  StyledAvatar,
  StyledDivider,
  StyledMenuItemBottom,
  StyledMenuItemTop,
  StyledPopper,
  StyledPopperBox,
  UserDataName,
  UserDataPosition,
  UserDataWrapper,
  Wrapper,
} from './UserInfoV2.styles';

import { isV2PermissionsEnabled } from '../../../helpers/featureFlags/isV2PermissionsEnabled';
import { isRbacRole } from '../../../helpers/isRbacRole';
import { useUserInfo } from '../../../utils/permissions';

const UserInfo = ({
  userName,
  userData,
  flexpertImg,
  anchorEl,
  userEmail,
  openMenu,
  closeMenu,
  forwardTo,
  logout,
}) => {
  const arrowRef = useRef();

  const APPLICATION_NAMES = {
    PLATFORM: 'Platform',
    AGILE: 'Fast & MK2',
  };

  const { userInfo } = useUserInfo();

  const rbacRole = userInfo?.roleAssociations?.filter(
    (role) => role.application === APPLICATION_NAMES.PLATFORM,
  )[0]?.code;

  const agileRole = userInfo?.roleAssociations?.filter(
    (role) => role.application === APPLICATION_NAMES.AGILE,
  )[0]?.name;

  const showRbacLinkButton = isRbacRole(rbacRole) && isV2PermissionsEnabled();

  // const isFlexpert = userData?.Flexpert?.length ? 'Flexpert' : '';

  return (
    <Wrapper>
      <UserDataWrapper>
        <UserDataName component="span">{userName}</UserDataName>
        {agileRole ? <UserDataPosition component="span">{agileRole}</UserDataPosition> : null}
      </UserDataWrapper>
      <IconButton onClick={openMenu}>
        {flexpertImg ? <StyledAvatar /> : <StyledAccountIcon />}
      </IconButton>
      <StyledPopper
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        placement="bottom-end"
        modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
      >
        <ClickAwayListener onClickAway={closeMenu}>
          <StyledPopperBox>
            <PopperArrow ref={arrowRef} />
            <NameText>{userEmail}</NameText>
            {/* TODO: will be uncommented as soon as we display RBAC's provider name */}
            {/* {roleText ? <RoleText>{roleText}</RoleText> : null}
            <CompanyName>CBRE, Inc</CompanyName> */}
            <StyledDivider />
            {showRbacLinkButton && (
              <StyledMenuItemTop onClick={forwardTo}>User Management</StyledMenuItemTop>
            )}
            <StyledMenuItemBottom onClick={logout}>Sign Out</StyledMenuItemBottom>
          </StyledPopperBox>
        </ClickAwayListener>
      </StyledPopper>
    </Wrapper>
  );
};

export default UserInfo;
